import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

// State interface
interface UserState {
  name: string;
  isAdmin: boolean;
  roles: string[];
}

// Initial state
const initialState: UserState = {
  name: '',
  isAdmin: false,
  roles: [],
};

export const UserStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed((store) => ({
    // Computed selector for visible menu items based on user roles
    visibleMenuItems: computed(() => {
      const roles = store.roles();
      const obj = {
        ref: roles.some((r) => /ITSupport|Crude/gi.test(r)),
        lng: roles.some((r) => /LNG/gi.test(r)),
        lpg: roles.some((r) => /LPG/gi.test(r)),
        crude: roles.some((r) => /Crude/gi.test(r)),
        admin: roles.some((r) => /ITSupport/gi.test(r)),
      };
      return Object.entries(obj)
        .filter(([, v]) => v)
        .map(([k]) => k);
    }),
  })),
  withMethods((store) => ({
    // Method to set user information
    setUser: (user: { name: string; isAdmin: boolean; roles: string[] }) => {
      patchState(store, {
        name: user.name,
        isAdmin: user.isAdmin,
        roles: user.roles,
      });
    },
  })),
);
